<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <record-select-group v-model="teamId1" label="Home team" :dataset-id="datasetId"
                           v-if="datasetId"></record-select-group>
      <record-select-group v-model="teamId2" label="Away team" :dataset-id="datasetId"
                           v-if="datasetId"></record-select-group>
      <div class="form-group form-row">
        <label :for="safeId('period')" class="col-sm-4 col-form-label">Period</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('period')" v-model.lazy="period">
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Home score</label>
        <div class="col-sm-2">
          <input type="number" class="form-control" :id="safeId('score1')" v-model.lazy.number="score1" min="0">
        </div>
        <div class="col-sm-3">
          <button class="btn btn-block btn-secondary" @click="shiftHomeScore(+1)">+1</button>
        </div>
        <div class="col-sm-3">
          <button class="btn btn-block btn-secondary" @click="shiftHomeScore(-1)">-1</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Away score</label>
        <div class="col-sm-2">
          <input type="number" class="form-control" :id="safeId('score2')" v-model.lazy.number="score2" min="0">
        </div>
        <div class="col-sm-3">
          <button class="btn btn-block btn-secondary" @click="shiftAwayScore(+1)">+1</button>
        </div>
        <div class="col-sm-3">
          <button class="btn btn-block btn-secondary" @click="shiftAwayScore(-1)">-1</button>
        </div>
      </div>
      <clock-control :template-id="templateId"></clock-control>
      <floorball-scoreboard-penalty :template-id="templateId"></floorball-scoreboard-penalty>
    </window-tab>
    <window-tab title="Data" icon="database">
      <dataset-select-group v-model="datasetId" label="Teams" :show-fields="true"></dataset-select-group>
      <text-input-group v-model="patternName" label="Name"></text-input-group>
      <text-input-group v-model="patternCountry" label="Country"></text-input-group>
      <text-input-group v-model="patternPicture" label="Picture"></text-input-group>
      <album-select-group v-model="albumId"></album-select-group>
      <record-select-group v-model="teamId1" label="Home team" :dataset-id="datasetId"
                           v-if="datasetId"></record-select-group>
      <div class="form-group form-row">
        <label :for="safeId('name1')" class="col-sm-4 col-form-label">Home name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('name1')" v-model.lazy="name1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('country1')" class="col-sm-4 col-form-label">Home country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('country1')" v-model.lazy="country1">
        </div>
      </div>
      <picture-select-group v-model="pictureId1" :album-id="albumId" label="Home picture"></picture-select-group>
      <record-select-group v-model="teamId2" label="Away team" :dataset-id="datasetId"
                           v-if="datasetId"></record-select-group>
      <div class="form-group form-row">
        <label :for="safeId('name2')" class="col-sm-4 col-form-label">Away name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('name2')" v-model.lazy="name2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('country2')" class="col-sm-4 col-form-label">Away country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('country2')" v-model.lazy="country2">
        </div>
      </div>
      <picture-select-group v-model="pictureId2" :album-id="albumId" label="Away picture"></picture-select-group>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId">
        <div class="form-group form-row">
          <label class="col-sm-4 col-form-label">Start time</label>
          <div class="col-sm-8">
            <div class="form-group">
              <div class="form-row align-items-end">
                <div class="col">
                  <label :for="safeId('startHours')" class="col-form-label">Hours</label>
                  <input type="number" :id="safeId('startHours')" class="form-control"
                         v-model.number="startHours" min="0" max="99">
                </div>
                <div class="col">
                  <label :for="safeId('startMins')" class="col-form-label">Mins</label>
                  <input type="number" :id="safeId('startMins')" class="form-control"
                         v-model.number="startMins" min="0" max="59">
                </div>
                <div class="col">
                  <label :for="safeId('startSecs')" class="col-form-label">Secs</label>
                  <input type="number" :id="safeId('startSecs')" class="form-control"
                         v-model.number="startSecs" min="0" max="59">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-sm-4 col-form-label">End time</label>
          <div class="col-sm-8">
            <div class="form-group">
              <div class="form-row align-items-end">
                <div class="col">
                  <label :for="safeId('endHours')" class="col-form-label">Hours</label>
                  <input type="number" :id="safeId('endHours')" class="form-control"
                         v-model.number="endHours" min="0" max="99">
                </div>
                <div class="col">
                  <label :for="safeId('endMins')" class="col-form-label">Mins</label>
                  <input type="number" :id="safeId('endMins')" class="form-control"
                         v-model.number="endMins" min="0" max="59">
                </div>
                <div class="col">
                  <label :for="safeId('endSecs')" class="col-form-label">Secs</label>
                  <input type="number" :id="safeId('endSecs')" class="form-control"
                         v-model.number="endSecs" min="0" max="59">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-sm-4 col-form-label">Format</label>
          <div class="col-sm-8">
            <div class="form-group">
              <div class="form-row align-items-end">
                <div class="col">
                  <label :for="safeId('hrs')">Hours</label>
                  <b-form-select :id="safeId('hrs')" v-model="displayHours" :options="formatOptions"
                                 text-field="label" value-field="value">
                  </b-form-select>
                </div>
                <div class="col">
                  <div class="form-check form-check-inline">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" v-model="displayMinutes">Mins
                    </label>
                  </div>
                </div>
                <div class="col">
                  <div class="form-check form-check-inline">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" v-model="displayTenths">1/10
                    </label>
                  </div>
                </div>
                <div class="col">
                  <div class="form-check form-check-inline">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" v-model="displayHundredths">1/100
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template-settings>
    </window-tab>
  </window>
</template>

<script>
import { templateMixin } from '@/mixins'
import { mapOverlayData, mapOverlayOptions, mapRecord, mapTemplateData, mapTemplateOptions } from '../../utils/index'
import clockControl from './clock-control'
import * as action from '@/store/action-types'
import FloorballScoreboardPenalty from './floorball-scoreboard-penalty'

export default {
  name: 'floorball-scoreboard',
  mixins: [templateMixin],
  components: {FloorballScoreboardPenalty, clockControl},
  computed: {
    ...mapOverlayData(['name1', 'name2', 'country1', 'country2', 'period', 'direction']),
    ...mapOverlayData({
      'score1': {default: 0},
      'score2': {default: 0}
    }),
    ...mapOverlayOptions(['displayHours', 'displayMinutes', 'displayTenths', 'displayHundredths']),
    ...mapTemplateData(['albumId', 'datasetId', 'teamId1', 'teamId2', 'pictureId1', 'pictureId2']),
    ...mapTemplateOptions({
      'startTimeMs': {default: 0},
      'endTimeMs': {default: 0}
    }),
    ...mapTemplateData({
      /* eslint-disable no-template-curly-in-string */
      patternName: {default: '${NAME}'},
      patternPicture: {default: '${PICTURE}'},
      patternCountry: {default: '${COUNTRY}'}
      /* eslint-enable no-template-curly-in-string */
    }),
    startHours: {
      get () {
        return Math.floor(this.startTimeMs / 1000 / 3600)
      },
      set (val) {
        this.setStartTimeMs(val, this.startMins, this.startSecs)
      }
    },
    startMins: {
      get () {
        return Math.floor(this.startTimeMs / 1000 / 60 % 60)
      },
      set (val) {
        this.setStartTimeMs(this.startHours, val, this.startSecs)
      }
    },
    startSecs: {
      get () {
        return this.startTimeMs / 1000 % 60
      },
      set (val) {
        this.setStartTimeMs(this.startHours, this.startMins, val)
      }
    },
    endHours: {
      get () {
        return Math.floor(this.endTimeMs / 1000 / 3600)
      },
      set (val) {
        this.setEndTimeMs(val, this.endMins, this.endSecs)
      }
    },
    endMins: {
      get () {
        return Math.floor(this.endTimeMs / 1000 / 60 % 60)
      },
      set (val) {
        this.setEndTimeMs(this.endHours, val, this.endSecs)
      }
    },
    endSecs: {
      get () {
        return this.endTimeMs / 1000 % 60
      },
      set (val) {
        this.setEndTimeMs(this.endHours, this.endMins, val)
      }
    },
    formatOptions () {
      return [{label: 'Dynamic', value: 0}, {label: 'Always', value: 1}, {label: 'Never', value: 2}]
    }
  },
  watch: {
    teamId1: function (val) {
      const record = this.$store.getters.datasetRecord(this.datasetId, val) || null
      const values = mapRecord(record, {
        name: this.patternName,
        country: this.patternCountry,
        picture: this.patternPicture
      })
      this.name1 = values.name
      this.country1 = values.country
      const picture = this.$store.getters.picture(this.albumId, p => p.fileName === values.picture)
      console.log('pictureId1', picture && picture.pictureId)
      this.pictureId1 = picture && picture.pictureId
    },
    teamId2: function (val) {
      const record = this.$store.getters.datasetRecord(this.datasetId, val) || null
      const values = mapRecord(record, {
        name: this.patternName,
        country: this.patternCountry,
        picture: this.patternPicture
      })
      this.name2 = values.name
      this.country2 = values.country
      const picture = this.$store.getters.picture(this.albumId, p => p.fileName === values.picture)
      this.pictureId2 = picture && picture.pictureId
    },
    pictureId1: function (val) {
      const picture = this.$store.getters.picture(this.albumId, val) || null
      this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
        templateId: this.templateId,
        data: {picture1: picture}
      })
    },
    pictureId2: function (val) {
      const picture = this.$store.getters.picture(this.albumId, val) || null
      this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
        templateId: this.templateId,
        data: {picture2: picture}
      })
    },
    score1: function (val) {
      this.$store.dispatch(action.OVERLAY_DATA, {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: {score1: val}
      })
    },
    score2: function (val) {
      this.$store.dispatch(action.OVERLAY_DATA, {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: {score2: val}
      })
    }
  },
  methods: {
    setStartTimeMs (hours, mins, secs) {
      this.startTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1)
      this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down'
    },
    setEndTimeMs (hours, mins, secs) {
      this.endTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1)
      this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down'
    },
    shiftHomeScore (val) {
      this.score1 = Math.max(0, Number(this.score1) + val)
    },
    shiftAwayScore (val) {
      this.score2 = Math.max(0, Number(this.score2) + val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/floorball-scoreboard.vue